import { render, staticRenderFns } from "./store-log-table.vue?vue&type=template&id=23ef8c79&scoped=true&"
import script from "./store-log-table.vue?vue&type=script&lang=js&"
export * from "./store-log-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ef8c79",
  null
  
)

export default component.exports